import { Button, Popconfirm } from "antd";
import { isPermissionPresent } from "../../../../utilities/generalUtility";
import K from "../../../../utilities/constants";
import { convertIntoDashUSFormat } from "../../../../utilities/dateUtility";
import { DefaultColumnOptions } from "../../../../hooks/useDataGrid/options";

const createdAtRenderer = (params) =>
  params.data.createdAt
    ? convertIntoDashUSFormat(params.data.createdAt)
    : K.NullPlaceholder;

const actionColumnRenderer =
  (roles, downloadFile, deleteAttachment) => (params) => {
    return (
      <>
        <Button
          type="link"
          onClick={() => {
            downloadFile(params.data.attachment);
          }}
          className="text-primary-light"
        >
          Download
        </Button>
        {isPermissionPresent(K.Permissions.DeleteAttachment, roles) && (
          <Popconfirm
            title="Are you sure you'd like to delete this document?"
            onConfirm={(event, record) => {
              deleteAttachment(params.data);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button className="text-primary-light" type="link">
              Delete
            </Button>
          </Popconfirm>
        )}
      </>
    );
  };

export const getColumns = (roles, downloadFile, deleteAttachment) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Title",
    field: "title",
    sortable: true,
    sort: "asc",
    tooltipField: "title",
  },
  {
    headerName: "Uploaded By",
    field: "userName",
    sortable: true,
    tooltipField: "userName",
  },
  {
    headerName: "Uploaded At",
    field: "createdAt",
    sortable: true,
    tooltipField: "createdAt",
    tooltipComponent: createdAtRenderer,
    cellRenderer: createdAtRenderer,
  },
  {
    ...DefaultColumnOptions.Actions,
    cellRenderer: actionColumnRenderer(roles, downloadFile, deleteAttachment),
    width: 250,
  },
];
